import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_18'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_18',
  name: 'Does the facility have any of the following safety measures in place, when appropriate, regarding contractor safety?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_VERIFIES_THAT_CONTRACTOR_PERSONNEL_HAVE_APPROPRIATE_QU',
      text: 'Facility verifies that contractor personnel have appropriate qualifications and licenses for work being performed',
      externalIds: [
        {
          id: 'hs-54--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_PROVIDES_CONTRACTOR_PERSONNEL_WITH_A_SAFETY_ORIENTATIO',
      text: 'Facility provides contractor personnel with a safety orientation',
      externalIds: [
        {
          id: 'hs-54--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_MONITORS_CONTRACTED_PERSONNEL_TO_ENSURE_THEY_PERFORM_W',
      text: 'Facility monitors contracted personnel to ensure they perform work in a safe and legal manner',
      externalIds: [
        {
          id: 'hs-54--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SCAFFOLDING_IS_USED_IN_A_SAFE_WAY_I_E_SECURED_TO_A_PERMANENT_ST',
      text: 'Scaffolding is used in a safe way (i.e. secured to a permanent structure, able to carry intended load etc.)',
      externalIds: [
        {
          id: 'hs-54--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EXCAVATION_AND_OR_TRENCHING_WORK_IS_PERFORMED_IN_A_SAFE_WAY_I_E',
      text: 'Excavation and/or trenching work is performed in a safe way (i.e. will not damage or disrupt underground utilities, storage tanks, or other facilities)',
      externalIds: [
        {
          id: 'hs-54--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'A_FIRE_EXTINGUISHER_IS_PROVIDED_BY_THE_FACILITY_WHEN_HOT_WORKS_',
      text: 'A fire extinguisher is provided by the facility when hot works are performed (i.e. if the contractor did not bring their own)',
      externalIds: [
        {
          id: 'hs-54--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'IF_CHEMICALS_ARE_BROUGHT_INTO_THE_FACILITY_CONTRACTORS_SUBMIT_T',
      text: 'If chemicals are brought into the facility, contractors submit the relevant Safety Data Sheets ("SDS", formerly named MSDS) for review',
      externalIds: [
        {
          id: 'hs-54--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-54--1-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_VERIFIES_THAT_CONTRACTOR_PERSONNEL_HAVE_APPROPRIATE_QU',
                'FACILITY_PROVIDES_CONTRACTOR_PERSONNEL_WITH_A_SAFETY_ORIENTATIO',
                'FACILITY_MONITORS_CONTRACTED_PERSONNEL_TO_ENSURE_THEY_PERFORM_W',
                'SCAFFOLDING_IS_USED_IN_A_SAFE_WAY_I_E_SECURED_TO_A_PERMANENT_ST',
                'EXCAVATION_AND_OR_TRENCHING_WORK_IS_PERFORMED_IN_A_SAFE_WAY_I_E',
                'A_FIRE_EXTINGUISHER_IS_PROVIDED_BY_THE_FACILITY_WHEN_HOT_WORKS_',
                'IF_CHEMICALS_ARE_BROUGHT_INTO_THE_FACILITY_CONTRACTORS_SUBMIT_T',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-con-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17130,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
